<template>
  <div class="resultCreateDebt_warpper">
    <nav-bar titleText="提交结果" titleWeight="bold" @goBack="goBack"></nav-bar>
    <results-page
      @handleOperationClick="handleOperationClick"
      @handleReturnClick="handleReturnClick"
      operationDisplab
      operationText="查看订单"
      returnDisplab
      returnText="返回"
      :imgSrc="imgSrc"
      instructions="已成功提交审核"
    ></results-page>
  </div>
</template>
<script>
import navBar from "../components/navBar";
import resultsPage from "../components/resultsPage";
export default {
  name: "debt_resultSignature",
  data() {
    return {
     imgSrc:  require("../../../assets/debtor/resultOk.png")
    };
  },
  created() {},
  components: {
    navBar,
    resultsPage,
  },
  methods: {
    goBack() {
      // this.$router.go(-1);
      this.handleReturnClick()
    },
    handleOperationClick() { // this.$route.query.id
      // console.log(this.$route.query.debt_from)
      if(this.$route.query.debt_from == '债权'){
        this.$router.push({
          path: '/creditor/detail',
          query: {
            order_id: this.$route.query.id
          }
        })
      }
      if(this.$route.query.debt_from == '债务'){
        this.$router.push({
          path: '/debtor/detail',
          query: {
            order_id: this.$route.query.id
          }
        })
      }
     
    },
    // 返回事件，返回债务人首页
    handleReturnClick() {
      if(this.$route.query.debt_from == '债权'){
        this.$router.push('/creditor/creditorView')
      }
      if(this.$route.query.debt_from == '债务'){
        this.$router.push('/debtor/debtorView')
      }
    }
  }
};
</script>
<style lang="less">
.resultCreateDebt_warpper {
  padding-top: 88px;
  box-sizing: border-box;
  background-color: #f5f6f7;
  min-height: 100%;
  font-size: 16px;
  color: #333;
}
</style>
